import { PureComponent } from 'preact-compat'
import Button from '@insided/control/uikit/Button'
import { getIdAndContentTypeFromTopics } from '../../utils'
import { bulkRestore } from './service'
import RestoreModal from './RestoreModal'

/* eslint-disable import/no-internal-modules */
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import Icon from '@insided/deprecated-preact-components/assets'

interface RestoreState {
  showRestoreModal: boolean
}

class Restore extends PureComponent<BulkActionComponentProps, RestoreState> {
  constructor(props: BulkActionComponentProps) {
    super(props)
    this.onRestoreBulk = this.onRestoreBulk.bind(this)
  }

  state = {
    showRestoreModal: false
  }

  showRestoreModal(show: boolean) {
    this.setState({ showRestoreModal: show })
  }

  onRestoreBulk() {
    const { performBulkAction } = this.props
    return performBulkAction({
      onClick: async (topics: []) => await bulkRestore(getIdAndContentTypeFromTopics(topics)),
      successMessage: 'Post(s) successfully restored.'
    })
  }

  render() {
    const { showRestoreModal } = this.state

    return (
      <div>
        <Button
          title={
            <div>
              <Icon icon='restore' width={16} height={16} />
              Restore
            </div>
          }
          size='medium'
          variant='approval'
          className='qa-restore'
          onClick={() => {
            this.setState({ showRestoreModal: true })
          }}
        />
        {showRestoreModal && (
          <RestoreModal onRestore={this.onRestoreBulk} onClose={() => this.showRestoreModal(false)} />
        )}
      </div>
    )
  }
}

export default Restore
